module.exports = require("react-stripe-elements");


//////////////////
// WEBPACK FOOTER
// external "react-stripe-elements"
// module id = 21
// module chunks = 0